import type { SATTestInterventionArmTaskAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type AssociationDefinitions,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryOrderToSQL,
} from './common'
import SATTestInterventionArmQ from './SATTestInterventionArmQ'

const SATTestInterventionArmTaskQ = {
  ...makeQueryModelV2<SATTestInterventionArmTaskAttributes>('sat_test_intervention_arm_task')([
    'id',
    'name',
    'sat_test_intervention_arm_id',
    'link',
    'release_date',
    'due_date',
    'reminder_history',
    'for_learners',
    'created_at',
    'deleted_at',
    'updated_at',
  ]),

  associations: (): AssociationDefinitions => ({
    SATTestInterventionArm: {
      query: SATTestInterventionArmQ,
      foreignKey: SATTestInterventionArmQ.id,
      sourceKey: SATTestInterventionArmTaskQ.sat_test_intervention_arm_id,
    },
  }),

  where: (
    {
      id = null,
      satTestInterventionArmId,
      include = [],
      paranoid = true,
      order = null,
    }: {
      id?: number | null | SQLFragment<number>
      satTestInterventionArmId?: number | null | SQLFragment<number>
      include?: IncludeAssociations
      paranoid?: boolean
      order?: QueryOrder | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<SATTestInterventionArmTaskAttributes> => SQL`
        FROM ${SATTestInterventionArmTaskQ}
        ${includeAssociationsToSql(SATTestInterventionArmTaskQ, include)}
        WHERE
            ${id != null ? SQL`${SATTestInterventionArmTaskQ.id} = ${id} AND` : SQL``}
            ${
              satTestInterventionArmId != null
                ? SQL`${SATTestInterventionArmTaskQ.sat_test_intervention_arm_id} = ${satTestInterventionArmId} AND`
                : SQL``
            }
            ${paranoid ? SQL`${SATTestInterventionArmTaskQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryOrderToSQL(order)}
    `,
}

export default SATTestInterventionArmTaskQ
